import { render, staticRenderFns } from "./SignUpPageLanguage.vue?vue&type=template&id=a3a3a13c&"
import script from "./SignUpPageLanguage.vue?vue&type=script&lang=js&"
export * from "./SignUpPageLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports